export const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase());
}

export const validateName = (nombre) => {
  const re = /^[A-Za-zñÑáéíóúÁÉÍÓÚ]+$/;
  return re.test(nombre);
}
